import { createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../../api/services/user";

export const signUpStudent = createAsyncThunk(
  "studentInfo/signUpStudent",
  async (requestData) => {
    const { email, imageFile, firstName, lastName, studentId, graduationYear } =
      requestData;
    let formData = new FormData();

    if (imageFile) {
      formData.append("file", imageFile);
    }
    formData.append("studentId", studentId);
    formData.append("graduationYear", graduationYear);
    formData.append("email", email);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    return await userService.signUpStudent(formData);
  }
);

export const fetchStudents = createAsyncThunk(
  "studentInfo/fetchStudents",
  async (requestData) => {
    const { page, sortBy, order, search } = requestData;
    return await userService.fetchStudents(page, sortBy, order, search);
  }
);

export const editStudent = createAsyncThunk(
  "studentInfo/editStudent",
  async (requestData) => {
    const {
      email,
      imageFile,
      firstName,
      lastName,
      studentId,
      graduationYear,
      id,
    } = requestData;
    let formData = new FormData();

    if (imageFile) {
      formData.append("file", imageFile);
    }
    formData.append("id", id);
    formData.append("studentId", studentId);
    formData.append("graduationYear", graduationYear);
    formData.append("email", email);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    return await userService.editStudent(formData);
  }
);
